import React, { memo, useState } from 'react';
import { Button } from 'reactstrap';

export const DeleteButton = memo(function DeleteButton({ onConfirm }) {
    const [ confirming, setConfirming ] = useState(false);

    if (confirming) {
        return (<div>
            <Button
                color={ 'link' }
                onClick={ onConfirm }
            >Confirm delete</Button>
            <Button
                color={ 'link' }
                onClick={ () => setConfirming(false) }
            >
                cancel
            </Button>
        </div>);
    }

    return (<div>
        <Button
            color={ 'link' }
            onClick={ () => setConfirming(true) }
        >
            Delete
        </Button>
    </div>);
});
